import { CentralProfileLink } from '../../../frontend/user/CentralAccounts';
export default function ChangePassword() { return <CentralProfileLink path="/security?product=cms" />; }
